import React from 'react';
import { Badge, BadgeVariants } from '@morressier/alembic';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IReviewBadge, REVIEW_RECOMMENDATION_MAP } from '@publishing-engine/domain/utils';

const RecommendationBadge: React.FC<{ recommendation: string }> = ({
  recommendation
}) => {
  const { variant, icon, label } = (REVIEW_RECOMMENDATION_MAP[recommendation] ||
    REVIEW_RECOMMENDATION_MAP.default) as IReviewBadge;

  return (
    <Badge variant={variant as BadgeVariants} size="context">
      <FontAwesomeIcon icon={icon} /> {label}
    </Badge>
  );
};

export default RecommendationBadge;
